function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Stream Trade",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Stream Trade_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-22",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.0147 4.61914C17.7457 4.61914 18.3385 5.22015 18.3385 5.96119C18.3385 6.70224 17.7457 7.30325 17.0147 7.30325C16.2837 7.30325 15.6908 6.70224 15.6908 5.96119C15.6908 5.22015 16.2837 4.61914 17.0147 4.61914Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-24",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.12959 16.6964C8.86059 16.6964 9.45346 17.2974 9.45346 18.0385C9.45346 18.7795 8.86059 19.3805 8.12959 19.3805C7.39859 19.3805 6.80573 18.7795 6.80573 18.0385C6.80573 17.2974 7.39859 16.6964 8.12959 16.6964Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-26",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7042 12.6709H11.0565C9.59672 12.6709 8.40933 11.4666 8.40933 9.98679C8.40933 8.50695 9.59672 7.30325 11.0565 7.30325H13.7042C14.4352 7.30325 15.0281 6.70224 15.0281 5.96119C15.0281 5.22015 14.4352 4.61914 13.7042 4.61914H11.0565C8.13693 4.61914 5.7616 7.02711 5.7616 9.98679C5.7616 12.9465 8.13693 15.355 11.0565 15.355H13.7042C14.4352 15.355 15.0281 14.754 15.0281 14.013C15.0281 13.2713 14.4352 12.6709 13.7042 12.6709Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-28",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7051 8.64502H11.0574C10.3264 8.64502 9.73407 9.24547 9.73407 9.98707C9.73407 10.7281 10.3264 11.3291 11.0574 11.3291H13.7051C15.1649 11.3291 16.3528 12.5328 16.3528 14.0127C16.3528 15.4925 15.1649 16.6968 13.7051 16.6968H11.0574C10.3264 16.6968 9.73407 17.2972 9.73407 18.0388C9.73407 18.7799 10.3264 19.3809 11.0574 19.3809H13.7051C16.6247 19.3809 19 16.9724 19 14.0127C19 11.053 16.6247 8.64502 13.7051 8.64502Z",
  fill: "none"
})));

var SvgStreamTrade = function SvgStreamTrade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStreamTrade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stream_trade.3df44e3a.svg";
export { ForwardRef as ReactComponent };